export const EXTRA_MARKET_NAMES_LANGPACK: Record<string, Record<string, string>> = {
    "en": {
        "All": "All",
        "Main": "Main Bets",
        "Handicap": "Handicap",
        "OverUnder": "Over/Under",
        "Goals": "Goals",
        "Half": "Half",
        "Player": "Players",
        "Specials": "Special Bets",
        "Corners": "Corners",
        // Legacy keys
        "Hauptwetten": "Main Markets",
        "Tore": "Goals",
        "1. Halbzeit": "1st Half",
        "2. Halbzeit": "2nd Half",
        "Über/Unter": "Over/Under",
        "Ecken": "Corners",
        "Spieler": "Players",
        "Main Markets": "Main Markets",
        "Totals": "Totals",
        "Players": "Players",
        "1st Half": "1st Half",
        "2nd Half": "2nd Half",
        "Score": "Score",
        "Home Team": "Home Team",
        "Away Team": "Away Team",
        "All Periods": "All Periods",
        "Results": "Results",
        "Winner": "Winner",
        "Home / Away": "Home / Away"
    },
    "tr": {
        "All": "Tüm Bahisler",
        "Main": "Ana Bahisler",
        "Handicap": "Handikap",
        "OverUnder": "Alt/Üst",
        "Goals": "Goller",
        "Half": "Devre",
        "Player": "Oyuncular",
        "Specials": "Özel Bahisler",
        "Corners": "Kornerler",
        // Legacy keys
        "Hauptwetten": "Ana Bahisler",
        "Tore": "Goller",
        "1. Halbzeit": "1. Yarı",
        "2. Halbzeit": "2. Yarı",
        "Über/Unter": "Alt/Üst",
        "Ecken": "Kornerler",
        "Spieler": "Oyuncular",
        "Main Markets": "Ana Marketler",
        "Totals": "Toplam",
        "Players": "Oyuncular",
        "1st Half": "1. Yarı",
        "2nd Half": "2. Yarı",
        "Score": "Skor",
        "Home Team": "Ev Sahibi",
        "Away Team": "Deplasman",
        "All Periods": "Tüm Periyotlar",
        "Results": "Sonuçlar",
        "Winner": "Kazanan",
        "Home / Away": "Ev / Deplasman"
    },
    "de": {
        "All": "Alle Wetten",
        "Main": "Hauptwetten",
        "Handicap": "Handicap",
        "OverUnder": "Über/Unter",
        "Goals": "Tore",
        "Half": "Halbzeit",
        "Player": "Spieler",
        "Specials": "Spezialwetten",
        "Corners": "Ecken",
        // Legacy keys
        "Hauptwetten": "Hauptwetten",
        "Tore": "Tore",
        "1. Halbzeit": "1. Halbzeit",
        "2. Halbzeit": "2. Halbzeit",
        "Über/Unter": "Über/Unter",
        "Ecken": "Ecken",
        "Spieler": "Spieler",
        "Main Markets": "Hauptmärkte",
        "Totals": "Gesamt",
        "Players": "Spieler",
        "1st Half": "1. Halbzeit",
        "2nd Half": "2. Halbzeit",
        "Score": "Ergebnis",
        "Home Team": "Heimteam",
        "Away Team": "Auswärtsteam",
        "All Periods": "Alle Perioden",
        "Results": "Ergebnisse",
        "Winner": "Gewinner",
        "Home / Away": "Heim / Auswärts"
    },
    "fr": {
        "All": "Tous",
        "Main": "Paris Principaux",
        "Handicap": "Handicap",
        "OverUnder": "Plus/Moins",
        "Goals": "Buts",
        "Half": "Mi-temps",
        "Player": "Joueurs",
        "Specials": "Spéciaux",
        "Corners": "Corners",
        "Hauptwetten": "Paris Principaux",
        "Tore": "Buts",
        "1. Halbzeit": "1ère Mi-temps",
        "2. Halbzeit": "2ème Mi-temps",
        "Über/Unter": "Plus/Moins",
        "Ecken": "Corners",
        "Spieler": "Joueurs",
        "Main Markets": "Marchés Principaux",
        "Totals": "Totaux",
        "Players": "Joueurs",
        "1st Half": "1ère Mi-temps",
        "2nd Half": "2ème Mi-temps",
        "Score": "Score",
        "Home Team": "Équipe Domicile",
        "Away Team": "Équipe Extérieure",
        "All Periods": "Toutes les Périodes",
        "Results": "Résultats",
        "Winner": "Vainqueur",
        "Home / Away": "Domicile / Extérieur"
    },
    "it": {
        "All": "Tutti",
        "Main": "Scommesse Principali",
        "Handicap": "Handicap",
        "OverUnder": "Under/Over",
        "Goals": "Gol",
        "Half": "Tempo",
        "Player": "Giocatori",
        "Specials": "Speciali",
        "Corners": "Calci d'angolo",
        "Hauptwetten": "Scommesse Principali",
        "Tore": "Gol",
        "1. Halbzeit": "1° Tempo",
        "2. Halbzeit": "2° Tempo",
        "Über/Unter": "Under/Over",
        "Ecken": "Calci d'angolo",
        "Spieler": "Giocatori",
        "Main Markets": "Mercati Principali",
        "Totals": "Totali",
        "Players": "Giocatori",
        "1st Half": "1° Tempo",
        "2nd Half": "2° Tempo",
        "Score": "Risultato",
        "Home Team": "Squadra Casa",
        "Away Team": "Squadra Trasferta",
        "All Periods": "Tutti i Periodi",
        "Results": "Risultati",
        "Winner": "Vincitore",
        "Home / Away": "Casa / Trasferta"
    },
    "nl": {
        "All": "Alles",
        "Main": "Hoofd Weddenschappen",
        "Handicap": "Handicap",
        "OverUnder": "Over/Under",
        "Goals": "Doelpunten",
        "Half": "Helft",
        "Player": "Spelers",
        "Specials": "Specials",
        "Corners": "Corners",
        "Hauptwetten": "Hoofd Weddenschappen",
        "Tore": "Doelpunten",
        "1. Halbzeit": "1e Helft",
        "2. Halbzeit": "2e Helft",
        "Über/Unter": "Over/Under",
        "Ecken": "Corners",
        "Spieler": "Spelers",
        "Main Markets": "Hoofdmarkten",
        "Totals": "Totalen",
        "Players": "Spelers",
        "1st Half": "1e Helft",
        "2nd Half": "2e Helft",
        "Score": "Score",
        "Home Team": "Thuisteam",
        "Away Team": "Uitteam",
        "All Periods": "Alle Periodes",
        "Results": "Resultaten",
        "Winner": "Winnaar",
        "Home / Away": "Thuis / Uit"
    },
    "ru": {
        "All": "Все",
        "Main": "Основные ставки",
        "Handicap": "Фора",
        "OverUnder": "Тотал",
        "Goals": "Голы",
        "Half": "Тайм",
        "Player": "Игроки",
        "Specials": "Специальные ставки",
        "Corners": "Угловые",
        // Legacy keys
        "Hauptwetten": "Основные ставки",
        "Tore": "Голы",
        "1. Halbzeit": "1-й Тайм",
        "2. Halbzeit": "2-й Тайм",
        "Über/Unter": "Тотал",
        "Ecken": "Угловые",
        "Spieler": "Игроки",
        "Main Markets": "Основные рынки",
        "Totals": "Итоговые",
        "Players": "Игроки",
        "1st Half": "1-й Тайм",
        "2nd Half": "2-й Тайм",
        "Score": "Счет",
        "Home Team": "Домашняя команда",
        "Away Team": "Гостевая команда",
        "All Periods": "Все Периоды",
        "Results": "Результаты",
        "Winner": "Победитель",
        "Home / Away": "Домашняя / Гостевая"
    }
};

interface SportGroupData {
    extraMarketNames: string[];
    [key: string]: any; 
}

// ────────────────────────────────────────────────────────────────
// Soccer market IDs mapped to Tipico categories
// ────────────────────────────────────────────────────────────────

const soccerMain = {
    // Tipico "Ana Bahisler" (Hauptwetten) ordering:
    // 1. Maç Sonucu, 2. Çifte Şans, 3. Handikap, 4. Üst/Alt
    // 5. Sıradaki Gol, 6. Kim çıkacak, 7. 1.Yarı Sonucu, 8. 1.Yarı Üst/Alt
    // 9. İki takımda gol atar, 10. Beraberlikte İade
    // 11. Üst/Alt & Maç Sonucu, 12. Maç Skoru, 13. Maç Sonucu & Karşılıklı gol
    marketIds: [
        1,      // 1x2 (Maç Sonucu)
        5035,   // 1x2 Early Payout
        8,      // Nächstes Tor (Sıradaki Gol)
        9,      // Letztes Tor (Son Gol)
        10,     // Doppelte Chance (Çifte Şans)
        14, 16, // Handicap
        18,     // Total (Üst/Alt)
        7,      // Restzeit (Kim çıkacak / rest of match)
        60,     // 1.HZ - 1x2 (1. yarı sonucu)
        68,     // 1.HZ - Total (1.yarı Üst/Alt)
        29,     // Beide Mannschaften treffen (İki takımda gol atar)
        11,     // Draw No Bet (Beraberlikte İade)
        37,     // 1x2 & Total (Üst/Alt & Maç Sonucu)
        45,     // Genaues Ergebnis (Maç Skoru)
        35,     // 1x2 & Beide Mannschaften treffen (Maç Sonucu & Karşılıklı gol)
    ]
};

const soccerHandicap = {
    // Tipico "Handikap" ordering:
    // 1. Handikap, 2. İlk yarı handikap
    marketIds: [
        14, 16,     // Handicap (full match)
        65, 66,     // 1.HZ Handicap
        87, 88,     // 2.HZ Handicap
        117, 120,   // Verlängerung Handicap
    ]
};

const soccerOverUnder = {
    // Tipico "Üst/Alt" ordering:
    // 1. Üst/Alt, 2. 1.Yarı Üst/Alt, 3. 2.Yarı Üst/Alt
    // 4. Ev Sahibi Üst/Alt, 5. Deplasman Üst/Alt
    // 6. İki takım da gol atar & Üst/Alt
    // 7. Ev sahibi 1.Yarı Üst/Alt, 8. Deplasman 1.Yarı Üst/Alt
    marketIds: [
        18,         // Total (Üst/Alt)
        68,         // 1.HZ - Total
        90,         // 2.HZ - Total
        19,         // Ev sahibi Total
        20,         // Deplasman Total
        36,         // Total & Beide Mannschaften treffen (İki takım da gol atar & Üst/Alt)
        69,         // 1.HZ - Ev sahibi Total
        70,         // 1.HZ - Deplasman Total
        91,         // 2.HZ - Ev sahibi Total (ID 91 if exists)
        58, 59,     // Beide Hälften über/unter
    ]
};

const soccerGoals = {
    // Tipico "Goller" ordering:
    // 1. İlk golü kim atar, 2. 1.yarıda ilk golü kim atacak
    // 3. İki takımda gol atar, 4. Her iki takım da devrede gol atar mı
    // 5-6. Ev sahibi/Deplasman gol atar mı, 7-10. Yarılarda gol atar mı
    // 11. Kaç gol atılacak, 12-13. Takım toplam gol sayısı
    // 14. Belirtilen dakika arası goller
    marketIds: [
        8,          // Nächstes Tor (İlk golü kim atar / Sıradaki Gol)
        9,          // Letztes Tor (Son gol)
        62,         // 1.HZ - Sıradaki Gol
        29,         // Beide Mannschaften treffen (İki takımda gol atar)
        75,         // 1.HZ - Beide Mannschaften treffen
        95,         // 2.HZ - Beide Mannschaften treffen
        55,         // 1.HZ / 2.HZ Beide Mannschaften treffen
        56, 57,     // Takım her iki devrede de gol atar
        33, 34,     // Takım sıfıra karşı kazanır
        27, 28,     // Takım Gerade/Ungerade
        26,         // Gerade/Ungerade (Tek/Çift)
        41,         // Genaues Ergebnis (Doğru Skor detay)
        102, 105, 108, // Dakika aralığı bahisleri
    ]
};

const soccerHalf = {
    // Tipico "Devre" ordering:
    // 1. 1.yarı sonucu, 2. 2.yarı sonucu, 3. 1.yarı çifte şans
    // 4. 1.yarı handikap, 5. 1.yarı Üst/Alt, 6. 2.yarı Üst/Alt
    // 7. 1.yarıda ilk golü kim atacak, 8. Her iki takım da devrede gol atar mı
    // 9-12. Takım yarıda gol atar mı, 13-14. Takım yarı Üst/Alt
    // 15-16. Takım yarıyı kazanır mı, 17-18. Takım her iki devrede de gol atar mı
    // 19. Her iki yarıda her iki takım da gol atar, 20. Her iki yarıda da gol atılacak mı
    // 21. Hangi bölümde daha fazla gol, 22. İlk Devre/Maç Sonucu
    // 23. İlk yarı skoru, 24. İlk yarı veya Maç sonucu
    marketIds: [
        60,         // 1.HZ - 1x2 (1.yarı sonucu)
        83,         // 2.HZ - 1x2 (2.yarı sonucu)
        63,         // 1.HZ - Doppelte Chance (1.yarı çifte şans)
        85,         // 2.HZ - Doppelte Chance (2.yarı çifte şans)
        65, 66,     // 1.HZ - Handicap (1.yarı handikap)
        87, 88,     // 2.HZ - Handicap (2.yarı handikap)
        68,         // 1.HZ - Total (1.yarı Üst/Alt)
        90,         // 2.HZ - Total (2.yarı Üst/Alt)
        64,         // 1.HZ - Draw No Bet
        86,         // 2.HZ - Draw No Bet
        62,         // 1.HZ - Sıradaki Gol
        75,         // 1.HZ - Beide Mannschaften treffen
        95,         // 2.HZ - Beide Mannschaften treffen
        55,         // 1.HZ / 2.HZ Beide Mannschaften treffen
        69, 70,     // 1.HZ - Takım Total
        91,         // 2.HZ - Ev Sahibi Total (if exists)
        50, 51,     // Takım yarıyı kazanır mı
        48, 49,     // Takım her iki yarıyı da kazanır mı
        56, 57,     // Takım her iki devrede de gol atar mı
        52,         // HZ mit den meisten Toren (hangi bölümde daha fazla gol)
        53, 54,     // Takım en gollü devresi
        47,         // HZ/Maç Sonucu (İlk Devre/Maç Sonucu)
        46,         // HZ/reg. Spielzeit - Genaues Ergebnis
        81,         // 1.HZ - Genaues Ergebnis (1.yarı skoru)
        98,         // 2.HZ - Genaues Ergebnis
        74,         // 1.HZ - Gerade/Ungerade
        94,         // 2.HZ - Gerade/Ungerade
        78,         // 1.HZ - 1x2 & Beide Mannschaften treffen
        79,         // 1.HZ - 1x2 & Total
        58, 59,     // Beide Hälften über/unter
        80,         // 1.HZ - Genaues Ergebnis detay
    ]
};

const soccerPlayer = {
    marketIds: [38, 39, 40]
};

const soccerSpecials = {
    // Tipico "Özel Bahisler" ordering:
    // 1. Üst/Alt & Maç Sonucu, 2. Maç Sonucu & Karşılıklı gol
    // 3. Maç sonucu ve 1. gol, 4. Çifte şans & Üst/Alt
    // 5. Çifte şans ve her iki takım da gol atar
    // 6. Takım sıfıra karşı kazanır
    // 7-8. 1.yarı kombine bahisler, 9. Çift/Tek
    marketIds: [
        37,         // 1x2 & Total (Üst/Alt & Maç Sonucu)
        35,         // 1x2 & Beide Mannschaften treffen (Maç Sonucu & Karşılıklı gol)
        36,         // Total & Beide Mannschaften treffen
        33, 34,     // Takım sıfıra karşı kazanır
        26,         // Gerade/Ungerade (Çift/Tek)
        45,         // Genaues Ergebnis (Doğru Skor)
        41,         // Genaues Ergebnis detay
        78,         // 1.HZ - 1x2 & Beide Mannschaften treffen
        79,         // 1.HZ - 1x2 & Total
        113,        // Verlängerung - 1x2
        117,        // Verlängerung - Handicap
        118,        // Verlängerung - Genaues Ergebnis
        119, 120, 121, // Verlängerung 1.HZ
        135, 136,   // Elfmeterschießen / Karten
    ]
};

const soccerCorners = {
    marketIds: [166, 167, 168, 172, 173, 175, 177, 178, 179, 183, 568, 569, 570, 571, 575, 576, 577, 578, 582, 583, 584, 585]
};

// "All" tab: shows a selection in specific order
const soccerAll = {
    marketIds: [1, 5035, 8, 9, 10, 14, 16, 18, 7, 60, 68, 29, 11, 37, 45, 35, -1]
};

// ────────────────────────────────────────────────────────────────
// Non-soccer sport configs (keep existing)
// ────────────────────────────────────────────────────────────────

const basketballIds = {
    main: [219, 1, 186, 251, 340, 7, 8, 10, 29, 35, 18, 14, 11, 9, 12, 13, 15, 16, 19, 20, 21, 23, 24, 25, 26, 27, 28, 30, 31, 32, 33, 34, 36, 37, 38, 39, 40, 41, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 100, 101, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 184, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 198, 199, 201, 220, 234, 237, 238, 239, 241, 268, 269, 270, 271, 272, 273, 297, 298, 300, 306, 314, 326, 327, 328, 329, 341, 342, 365, 366, 367, 368, 381, 382, 383, 384, 385, 386, 399, 400, 401, 429, 430, 431, 432, 433, 434, 435, 436, 437, 438, 439, 440, 441, 442, 467, 473, 474, 475, 476, 477, 478, 479, 480, 481, 491, 492, 493, 494, 495, 496, 525, 526, 532, 540, 541, 546, 547, 548, 549, 550, 551, 563, 601, 604, 609, 634, 723, 724, 737, 738, 740, 818, 819, 820, 850, 851, 852, 853, 854, 855, 856, 857, 858, 859, 860, 861, 862, 863, 864, 865, 879, 880, 881, 888, 889, 890, 891, 892, 893, 896, 898, 899, 900, 901, 902, 968, 969, 1055, 1058, 1059, 1060],
    home_team: [97, 101, 106, 137, 149, 153, 154, 198, 202, 203, 204, 221, 223, 278, 387, 1065, 1066, 1229],
    away_team: [22, 96, 102, 107, 138, 150, 155, 156, 199, 202, 203, 204, 220, 222, 279, 388, 1067, 1068, 1230],
    totals: [26, 27, 28, 74, 94, 131, 132, 133, 172, 183, 198, 205, 213, 229, 248, 264, 295, 304, 311, 325, 359, 360, 361, 368, 373, 419, 462, 481, 490, 495, 502, 571, 578, 585, 608, 616, 617, 618, 619, 621, 690, 691, 745, 820],
    all: [219, 1, 186, 251, 340, 60, 83, 7, 61, 8, 62, 10, 29, 35, 18, 14, 11, 68, 69, 70, 90, -1]
};

const tennisIds = {
    main: [186, 187, 188, 189, 201, 212, 217],
    totals: [187, 213, 221],
    handicap: [188, 189],
    periods: [201, 202, 203, 204, 205, 198, 199, 200, 225],
    all: [186, 187, 188, 189, 198, 199, 200, 201, 202, 203, 204, 205, 212, 213, 217, 221, 225, -1]
};

// ────────────────────────────────────────────────────────────────
// Soccer config (Tipico-aligned)
// ────────────────────────────────────────────────────────────────

const soccerConfig: SportGroupData = {
    extraMarketNames: ["All", "Main", "Handicap", "OverUnder", "Goals", "Half", "Player", "Specials", "Corners"],
    "All": soccerAll,
    "Main": soccerMain,
    "Handicap": soccerHandicap,
    "OverUnder": soccerOverUnder,
    "Goals": soccerGoals,
    "Half": soccerHalf,
    "Player": soccerPlayer,
    "Specials": soccerSpecials,
    "Corners": soccerCorners,
};

// ────────────────────────────────────────────────────────────────
// Global market order per sport ID
// ────────────────────────────────────────────────────────────────

export const GLOBAL_MARKET_ORDER: Record<number, SportGroupData> = {
    1: soccerConfig,    // Soccer
    12: soccerConfig,   // Futsal
    137: soccerConfig,  // ESoccer
    6: soccerConfig,    // Handball (similar structure)
    22: {
        extraMarketNames: ["All", "Main", "OverUnder"],
        "Main": { marketIds: soccerMain.marketIds },
        "OverUnder": { marketIds: soccerOverUnder.marketIds },
        "All": soccerAll
    },
    2: {
        extraMarketNames: ["All", "Main", "OverUnder", "Home Team", "Away Team", "All Periods"],
        "Main": { marketIds: basketballIds.main },
        "OverUnder": { marketIds: basketballIds.totals },
        "Home Team": { marketIds: basketballIds.home_team },
        "Away Team": { marketIds: basketballIds.away_team },
        "All Periods": { marketIds: [443, 444, 445, 446, 447, 448, 449, 450, 451, 452, 453, 454, 455, 456, 457, 458, 459, 460, 462, 529] },
        "All": { marketIds: basketballIds.all }
    },
    153: {
        extraMarketNames: ["All", "Main", "OverUnder", "Home Team", "Away Team", "All Periods"],
        "Main": { marketIds: basketballIds.main },
        "OverUnder": { marketIds: basketballIds.totals },
        "Home Team": { marketIds: basketballIds.home_team },
        "Away Team": { marketIds: basketballIds.away_team },
        "All Periods": { marketIds: [443, 444, 445, 446, 447, 448, 449, 450, 451, 452, 453, 454, 455, 456, 457, 458, 459, 460, 462, 529] },
        "All": { marketIds: basketballIds.all }
    },
    3: {
        extraMarketNames: ["All", "Main", "OverUnder"],
        "Main": { marketIds: [1, 251, 264, 268] },
        "OverUnder": { marketIds: [258, 260, 261, 276, 288] },
        "All": { marketIds: [1, 251, 256, 258, 260, 261, 264, 268, -1] }
    },
    4: {
        extraMarketNames: ["All", "Main", "OverUnder", "Home Team", "Away Team"],
        "Main": { marketIds: basketballIds.main },
        "OverUnder": { marketIds: basketballIds.totals },
        "Home Team": { marketIds: basketballIds.home_team },
        "Away Team": { marketIds: basketballIds.away_team },
        "All": { marketIds: basketballIds.all }
    },
    5: {
        extraMarketNames: ["All", "Main", "OverUnder", "Handicap", "All Periods"],
        "Main": { marketIds: tennisIds.main },
        "OverUnder": { marketIds: tennisIds.totals },
        "Handicap": { marketIds: tennisIds.handicap },
        "All Periods": { marketIds: tennisIds.periods },
        "All": { marketIds: tennisIds.all }
    },
    20: {
        extraMarketNames: ["All", "Winner"],
        "Winner": { marketIds: [186] },
        "All": { marketIds: [186] }
    },
    31: {
        extraMarketNames: ["All", "Winner"],
        "Winner": { marketIds: [186] },
        "All": { marketIds: [186] }
    },
    23: {
        extraMarketNames: ["All", "Main", "OverUnder", "Home / Away"],
        "Main": { marketIds: soccerMain.marketIds },
        "OverUnder": { marketIds: soccerOverUnder.marketIds },
        "Home / Away": { marketIds: [101, 198, 202, 203, 204, 205, 206, 445, 909, 102, 910] },
        "All": { marketIds: basketballIds.all }
    },
    21: {
        extraMarketNames: ["All"],
        "All": { marketIds: [1, 251, 256, 258, 260, 340, 344, 351, 353, 357, 360, 607, 261, 264, 268, -1] }
    }
};

export const DEFAULT_MARKET_ORDER = GLOBAL_MARKET_ORDER[1];
